/**
 * 图片工具函数
 * 处理图片 URL，添加 CDN 域名前缀
 */

const cdnDomain = process.env.REACT_APP_CDN_DOMAIN;

/**
 * 为图片 URL 添加 CDN 域名前缀
 * @param {string} url - 图片 URL（可以是相对路径或完整 URL）
 * @returns {string} 处理后的完整图片 URL
 * @example
 * getImageUrl('/images/logo.png') // => 'https://cdn.cloudstaticfile.com/images/logo.png'
 * getImageUrl('https://example.com/image.jpg') // => 'https://example.com/image.jpg' (不修改完整 URL)
 * getImageUrl('') // => '' (空字符串不处理)
 * getImageUrl(null) // => '' (null/undefined 返回空字符串)
 */
export function getImageUrl(url) {
  // 如果 URL 为空、null 或 undefined，返回空字符串
  if (!url || typeof url !== 'string') {
    return '';
  }

  // 如果已经是完整 URL（以 http:// 或 https:// 开头），直接返回
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }

  // 如果 URL 以 / 开头，直接拼接 CDN 域名
  if (url.startsWith('/')) {
    return `${cdnDomain}${url.slice(1)}`;
  }

  // 否则，拼接 CDN 域名和 URL
  return `${cdnDomain}${url}`;
}

/**
 * 批量处理图片 URL 对象
 * @param {Object} data - 包含图片 URL 的对象
 * @param {string[]} imageFields - 需要处理的图片字段名数组
 * @returns {Object} 处理后的对象
 * @example
 * processImageUrls(
 *   { teamaLogoUrl: '/images/team1.png', teambLogoUrl: '/images/team2.png', name: 'test' },
 *   ['teamaLogoUrl', 'teambLogoUrl']
 * )
 * // => { teamaLogoUrl: 'https://cdn.cloudstaticfile.com/images/team1.png', ... }
 */
export function processImageUrls(data, imageFields = []) {
  if (!data || typeof data !== 'object') {
    return data;
  }

  const result = {...data};

  imageFields.forEach(field => {
    if (result[field]) {
      result[field] = getImageUrl(result[field]);
    }
  });

  return result;
}
